import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import Navbar from "./components/Navbar";

import ErrorNotFound from "./pages/ErrorNotFound";
import Home from "./pages/Home";
import Information from "./pages/Information";
import Gleamin from "./pages/Gleamin";
import Prints from "./pages/Prints";
import HomeboundFieldwork from "./pages/HomeboundFieldwork";
import PrintDetail from "./pages/PrintDetail";
import Cart from "./pages/Cart";
import PrintInformation from "./pages/PrintInformation";
import OrderStatus from "./pages/OrderStatus";

import ScrollTop from "./ScrollTop";

import AdminOrdersRoute from "./routes/AdminOrdersRoute";

import { CartProvider } from "./context/CartContext";

function App() {
  return (
    <CartProvider>
      <Router>
        <ScrollTop />

        <Navbar />

        <Switch>
          {/* ADMIN */}

          <Route path="/admin-orders" exact component={AdminOrdersRoute} />

          {/* PUBLIC */}

          <Route path="/info" exact component={Information} />

          <Route
            path="/prints/information"
            exact
            component={PrintInformation}
          />

          <Route path="/prints/:id" exact component={PrintDetail} />

          <Route path="/prints" exact component={Prints} />

          <Route path="/gleamin" exact component={Gleamin} />

          <Route path="/cart" exact component={Cart} />

          <Route path="/order-status" exact component={OrderStatus} />

          <Route
            path="/homebound-fieldwork"
            exact
            component={HomeboundFieldwork}
          />

          <Route path="/" exact component={Home} />

          <Route component={ErrorNotFound} />
        </Switch>
      </Router>
    </CartProvider>
  );
}

export default App;
